import request from '@/utils/request'
// 订单列表
export function orderList(params) {
  return request({
    url: '/order/list',
    method: 'get',
    params: params
  })
}
// 购物车确认订单
export function orderConfirmCart(params) {
  return request({
    url: '/order/orderConfirmCart',
    method: 'get',
    params: params
  })
}
// 购物车生产订单
export function orderSubmitCart(data) {
  return request({
    url: '/order/orderSubmitCart',
    method: 'post',
    data: data
  })
}
// 立即购买购买确认订单
export function orderConfirmBuy(params) {
  return request({
    url: '/order/orderConfirmBuy',
    method: 'get',
    params: params
  })
}
// 立即购买生产订单
export function orderSubmitBuy(data) {
  return request({
    url: '/order/orderSubmitBuy',
    method: 'post',
    data: data
  })
}
// 取消订单
export function orderCancel(id) {
  return request({
    url: '/order/cancel/' + id,
    method: 'post'
  })
}
// 确认收货
export function orderReceive(id) {
  return request({
    url: '/order/receive/' + id,
    method: 'post'
  })
}
// 订单信息-评价
export function orderInfo(id) {
  return request({
    url: '/order/info/' + id,
    method: 'get'
  })
}